import { useState, useEffect, useCallback } from "react";
import { API } from "../utility/Api";
import { UseToast } from "../components/context/ToastContext";

const useFetch = (url) => {
  const [fetchedData, setFetchedData] = useState({
    data: [],
    isLoading: true,
    error: false,
  });
  const { setMainMessage } = UseToast();
  const fetchData = useCallback(async () => {
    //eslint-disable-next-line
    AP.context.getToken(function (token) {
      getData(token);
    });
    const getData = async (token) => {
      try {
        const response = await API.get(url, {
          headers: {
            Authorization: `JWT ${token}`,
          },
        });
        const data = await response.data;
        if (data) {
          setFetchedData({
            data: data,
            isLoading: false,
            error: false,
          });
        }
      } catch (error) {
        setMainMessage({ appearance: "error", text: error.message });
        setFetchedData({
          data: [],
          isLoading: false,
          error: true,
        });
      }
    };
  }, [url]);
  useEffect(() => {
    fetchData();
  }, [url, fetchData]);
  const { data, isLoading, error } = fetchedData;
  return { data, isLoading, error };
};
export default useFetch;
